export default "__VITE_ASSET__C0iw1_sf__"